
import React from "react"
import { Container, Grid } from '@mui/material';
import ProjectCard from '../../components/Cards/ProjectCard';
import { projects } from './helper';
import { useWindowSize, isHorizontal } from '../../helper/functions/hooks/windowsize';
import RenderIf from "../../components/RenderIf";
import ProjectFallback from "./ProjectFallback";
const Projects = (): JSX.Element => {
    const { width, height } = useWindowSize()
    return (

        <RenderIf
            condition={isHorizontal(width, height)}
            fallback={<ProjectFallback />}>
            <Container>
                <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="center">
                    {
                        projects.map((proj, i) =>
                            <ProjectCard
                                key={i}
                                title={proj.title}
                                image={proj.image}
                                description={proj.description}
                                alt={proj.title}
                                link={proj.link} />
                        )
                    }
                </Grid>
            </Container>
        </RenderIf>
    )
}
export default Projects;
